import config from "appConfig";
import { getLinkForCourseLesson } from "../../../../services/Utils";

import lesson0106 from "../lesson-06/lesson";
const linkLesson0106 = getLinkForCourseLesson("41545ab2-1f99-40ea-8225-21d5e62ab7b0", lesson0106.id);

const theory = `<p>
We consider the problem of a wave propagating in a medium 1, which meets a medium 2 with an oblique incidence angle
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi>𝜃</mi>
</math> (see <a href="#" data-img-src=${config.ASSETS_URL}/01/12/theory/figure-1.svg data-img-alt="Figure 1. Reflection and transmission in oblique incidence.">Figure 1</a>). Both medium are characterised by their densities
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>ρ</mi>
      </mrow>
      <mrow>
         <mn>1</mn>
      </mrow>
   </msub>
   <mo class=MathClass-punc>,</mo>
   <msub>
      <mrow>
         <mi>ρ</mi>
      </mrow>
      <mrow>
         <mn>2</mn>
      </mrow>
   </msub>
</math>
and propagation velocities
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>c</mi>
      </mrow>
      <mrow>
         <mn>1</mn>
      </mrow>
   </msub>
   <mo class=MathClass-punc>,</mo>
   <msub>
      <mrow>
         <mi>c</mi>
      </mrow>
      <mrow>
         <mn>2</mn>
      </mrow>
   </msub>
</math>. The interface is assumed to be an infinite plane. The basis used is selected such that the interface is the plane of equation
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi>x</mi>
   <mo class=MathClass-rel>=</mo>
   <mn>0</mn>
</math>
and such that the direction of propagation of the incident wave is given by the vector
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
   <mrow>
      <mo mathvariant="bold">n</mo>
   </mrow>
<mrow>
   <mi>i</mi>
</mrow></msub>


<mo class=MathClass-rel>=</mo>
<mo class=MathClass-open>(</mo>
<mi class=qopname>cos</mi>
<mo>⁡</mo>
<msub>
   <mrow>
      <mi>𝜃</mi>
   </mrow>
   <mrow>
      <mi>i</mi>
   </mrow>
</msub>
<mo class=MathClass-punc>,</mo>
<mi class=qopname>sin</mi>
<mo>⁡</mo>
<msub>
   <mrow>
      <mi>𝜃</mi>
   </mrow>
   <mrow>
      <mi>i</mi>
   </mrow>
</msub>
<mo class=MathClass-punc>,</mo>
<mn>0</mn>
<mo class=MathClass-close>)</mo>
</math>. Likewise, for the reflected wave
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
   <mrow>
      <mo mathvariant="bold">n</mo>
   </mrow>
   <mrow>
   <mi>r</mi>
</mrow>
   </msub>
<mo class=MathClass-rel>=</mo>
<mo class=MathClass-open>(</mo>
<mo class=MathClass-bin>−</mo>
<mi class=qopname>cos</mi>
<mo>⁡</mo>
<msub>
   <mrow>
      <mi>𝜃</mi>
   </mrow>
   <mrow>
      <mi>r</mi>
   </mrow>
</msub>
<mo class=MathClass-punc>,</mo>
<mi class=qopname>sin</mi>
<mo>⁡</mo>
<msub>
   <mrow>
      <mi>𝜃</mi>
   </mrow>
   <mrow>
      <mi>r</mi>
   </mrow>
</msub>
<mo class=MathClass-punc>,</mo>
<mn>0</mn>
<mo class=MathClass-close>)</mo>
</math>
and for the transmitted wave
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
   <mrow>
   <mi mathvariant="bold">n</mi>
</mrow>
   <mrow>
   <mi>t</mi>
</mrow>
   </msub>
<mo class=MathClass-rel>=</mo>
<mo class=MathClass-open>(</mo>
<mi class=qopname>cos</mi>
<mo>⁡</mo>
<msub>
   <mrow>
      <mi>𝜃</mi>
   </mrow>
   <mrow>
      <mi>t</mi>
   </mrow>
</msub>
<mo class=MathClass-punc>,</mo>
<mi class=qopname>sin</mi>
<mo>⁡</mo>
<msub>
   <mrow>
      <mi>𝜃</mi>
   </mrow>
   <mrow>
      <mi>t</mi>
   </mrow>
</msub>
<mo class=MathClass-punc>,</mo>
<mn>0</mn>
<mo class=MathClass-close>)</mo>
</math>. Wave vectors are given by
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
   <mrow>
   <mi mathvariant="bold">k</mi>
</mrow>
   <mrow>
   <mi>i</mi>
</mrow>
   </msub>

<mo class=MathClass-rel>=</mo>
<msub>
   <mrow>
      <mi>k</mi>
   </mrow>
   <mrow>
      <mn>1</mn>
   </mrow>
</msub>
<msub>
   <mrow>
            <mi mathvariant="bold">n</mi>
   </mrow>
   <mrow>
      <mi>i</mi>
   </mrow>
</msub>
</math>,
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
   <mrow>
   <mi mathvariant="bold">k</mi>
</mrow>
<mrow>
   <mi>r</mi>
</mrow>
   </msub>

<mo class=MathClass-rel>=</mo>
<msub>
   <mrow>
      <mi>k</mi>
   </mrow>
   <mrow>
      <mn>1</mn>
   </mrow>
</msub>
<msub>
   <mrow>
            <mo mathvariant="bold">n</mo>
   </mrow>
   <mrow>
      <mi>r</mi>
   </mrow>
</msub>
</math>
and
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
   <mrow>
   <mi mathvariant="bold">k</mi>
</mrow>
<mrow>
   <mi>t</mi>
</mrow>
   </msub>
<mo class=MathClass-rel>=</mo>
<msub>
   <mrow>
      <mi>k</mi>
   </mrow>
   <mrow>
      <mn>2</mn>
   </mrow>
</msub>
<msub>
   <mrow>
            <mo mathvariant="bold">n</mo>
   </mrow>
   <mrow>
      <mi>i</mi>
   </mrow>
</msub>
</math>
for incident, reflected and transmitted waves respectively (
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>k</mi>
      </mrow>
      <mrow>
         <mn>1</mn>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <mi>ω</mi>
   <mo class=MathClass-bin>∕</mo>
   <msub>
      <mrow>
         <mi>c</mi>
      </mrow>
      <mrow>
         <mn>1</mn>
      </mrow>
   </msub>
</math>
and
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>k</mi>
      </mrow>
      <mrow>
         <mn>2</mn>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <mi>ω</mi>
   <mo class=MathClass-bin>∕</mo>
   <msub>
      <mrow>
         <mi>c</mi>
      </mrow>
      <mrow>
         <mn>2</mn>
      </mrow>
   </msub>
</math>).
<figure class=figure>
<p><img src=${config.ASSETS_URL}/01/12/theory/figure-1.svg alt="Figure 1. Reflection and transmission in oblique incidence."><figcaption class=caption>Figure 1. Reflection and transmission in oblique incidence.</figcaption></figure>
<h3 class=sectionHead>Snell-Descartes laws</h3>
<p>
Considering an arbitrary point
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi>M</mi>
</math>
of coordinates
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
<mi mathvariant="bold">r</mi>
<mo class=MathClass-rel>=</mo>
<mo class=MathClass-open>(</mo>
<mi>x</mi>
<mo class=MathClass-punc>,</mo>
<mi>y</mi>
<mo class=MathClass-punc>,</mo>
<mi>z</mi>
<mo class=MathClass-close>)</mo>
</math>, the complex amplitude of the pressure of the incident wave is given by
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>p</mi>
      </mrow>
      <mrow>
         <mi>i</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <msub>
      <mrow>
         <mi>A</mi>
      </mrow>
      <mrow>
         <mi>i</mi>
      </mrow>
   </msub>
   <msup>
      <mrow>
         <mi>e</mi>
      </mrow>
      <mrow>
         <mo class=MathClass-bin>−</mo>
         <mi>j</mi>
         <msub>
         <mrow>
               <mi mathvariant="bold">k</mi>
               </mrow>
         <mrow>
            <mi>i</mi>
         </mrow>
         </msub>
         <mo class=MathClass-bin>⋅</mo>
               <mi mathvariant="bold">r</mi>
      </mrow>
   </msup>

<mo class=MathClass-rel>=</mo>
<msub>
   <mrow>
      <mi>A</mi>
   </mrow>
   <mrow>
      <mi>i</mi>
   </mrow>
</msub>
<msup>
   <mrow>
      <mi>e</mi>
   </mrow>
   <mrow>
      <mo class=MathClass-bin>−</mo>
      <mi>j</mi>
      <msub>
         <mrow>
            <mi>k</mi>
         </mrow>
         <mrow>
            <mn>1</mn>
         </mrow>
      </msub>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mi class=qopname>cos</mi>
      <mo>⁡</mo>
      <msub>
         <mrow>
            <mi>𝜃</mi>
         </mrow>
         <mrow>
            <mi>i</mi>
         </mrow>
      </msub>
      <mo class=MathClass-bin>+</mo>
      <mi>y</mi>
      <mi class=qopname>sin</mi>
      <mo>⁡</mo>
      <msub>
         <mrow>
            <mi>𝜃</mi>
         </mrow>
         <mrow>
            <mi>i</mi>
         </mrow>
      </msub>
      <mo class=MathClass-close>)</mo>
   </mrow>
</msup>
</math>
for the incident wave,
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>p</mi>
      </mrow>
      <mrow>
         <mi>r</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <msub>
      <mrow>
         <mi>A</mi>
      </mrow>
      <mrow>
         <mi>r</mi>
      </mrow>
   </msub>
   <msup>
      <mrow>
         <mi>e</mi>
      </mrow>
      <mrow>
         <mo class=MathClass-bin>−</mo>
         <mi>j</mi>
         <msub>
<mrow>
      <mi mathvariant="bold">k</mi>
      </mrow>
<mrow>
   <mi>r</mi>
</mrow>
</msub>
<mo class=MathClass-bin>⋅</mo>
      <mi mathvariant="bold">r</mi>
      </mrow>
   </msup>

<mo class=MathClass-rel>=</mo>
<msub>
   <mrow>
      <mi>R</mi>
   </mrow>
   <mrow>
      <mi>p</mi>
   </mrow>
</msub>
<msub>
   <mrow>
      <mi>A</mi>
   </mrow>
   <mrow>
      <mi>i</mi>
   </mrow>
</msub>
<msup>
   <mrow>
      <mi>e</mi>
   </mrow>
   <mrow>
      <mo class=MathClass-bin>−</mo>
      <mi>j</mi>
      <msub>
         <mrow>
            <mi>k</mi>
         </mrow>
         <mrow>
            <mn>1</mn>
         </mrow>
      </msub>
      <mo class=MathClass-open>(</mo>
      <mo class=MathClass-bin>−</mo>
      <mi>x</mi>
      <mi class=qopname>cos</mi>
      <mo>⁡</mo>
      <msub>
         <mrow>
            <mi>𝜃</mi>
         </mrow>
         <mrow>
            <mi>r</mi>
         </mrow>
      </msub>
      <mo class=MathClass-bin>+</mo>
      <mi>y</mi>
      <mi class=qopname>sin</mi>
      <mo>⁡</mo>
      <msub>
         <mrow>
            <mi>𝜃</mi>
         </mrow>
         <mrow>
            <mi>r</mi>
         </mrow>
      </msub>
      <mo class=MathClass-close>)</mo>
   </mrow>
</msup>
</math>
for the reflected wave and
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>p</mi>
      </mrow>
      <mrow>
         <mi>t</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <msub>
      <mrow>
         <mi>A</mi>
      </mrow>
      <mrow>
         <mi>t</mi>
      </mrow>
   </msub>
   <msup>
      <mrow>
         <mi>e</mi>
      </mrow>
      <mrow>
         <mo class=MathClass-bin>−</mo>
         <mi>j</mi>
         <msub>
         <mrow>
         <mi mathvariant="bold">k</mi>
      </mrow>
<mrow>
   <mi>t</mi>
</mrow>
</msub>
<mo class=MathClass-bin>⋅</mo>
      <mi mathvariant="bold">r</mi>
      </mrow>
   </msup>
<mo class=MathClass-rel>=</mo>
<msub>
   <mrow>
      <mi>R</mi>
   </mrow>
   <mrow>
      <mi>t</mi>
   </mrow>
</msub>
<msub>
   <mrow>
      <mi>A</mi>
   </mrow>
   <mrow>
      <mi>i</mi>
   </mrow>
</msub>
<msup>
   <mrow>
      <mi>e</mi>
   </mrow>
   <mrow>
      <mo class=MathClass-bin>−</mo>
      <mi>j</mi>
      <msub>
         <mrow>
            <mi>k</mi>
         </mrow>
         <mrow>
            <mn>2</mn>
         </mrow>
      </msub>
      <mo class=MathClass-open>(</mo>
      <mi>x</mi>
      <mi class=qopname>cos</mi>
      <mo>⁡</mo>
      <msub>
         <mrow>
            <mi>𝜃</mi>
         </mrow>
         <mrow>
            <mi>t</mi>
         </mrow>
      </msub>
      <mo class=MathClass-bin>+</mo>
      <mi>y</mi>
      <mi class=qopname>sin</mi>
      <mo>⁡</mo>
      <msub>
         <mrow>
            <mi>𝜃</mi>
         </mrow>
         <mrow>
            <mi>t</mi>
         </mrow>
      </msub>
      <mo class=MathClass-close>)</mo>
   </mrow>
</msup>
</math>
for the transmitted wave, with
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>k</mi>
      </mrow>
      <mrow>
         <mn>1</mn>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <mfrac>
      <mrow>
         <mi>ω</mi>
      </mrow>
      <mrow>
         <msub>
            <mrow>
               <mi>c</mi>
            </mrow>
            <mrow>
               <mn>1</mn>
            </mrow>
         </msub>
      </mrow>
   </mfrac>
</math>
and
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>k</mi>
      </mrow>
      <mrow>
         <mn>2</mn>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <mfrac>
      <mrow>
         <mi>ω</mi>
      </mrow>
      <mrow>
         <msub>
            <mrow>
               <mi>c</mi>
            </mrow>
            <mrow>
               <mn>2</mn>
            </mrow>
         </msub>
      </mrow>
   </mfrac>
</math>,
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>R</mi>
      </mrow>
      <mrow>
         <mi>p</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <mfrac>
      <mrow>
         <msub>
            <mrow>
               <mi>A</mi>
            </mrow>
            <mrow>
               <mi>r</mi>
            </mrow>
         </msub>
      </mrow>
      <mrow>
         <msub>
            <mrow>
               <mi>A</mi>
            </mrow>
            <mrow>
               <mi>i</mi>
            </mrow>
         </msub>
      </mrow>
   </mfrac>
</math>
and
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>T</mi>
      </mrow>
      <mrow>
         <mi>p</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <mfrac>
      <mrow>
         <msub>
            <mrow>
               <mi>A</mi>
            </mrow>
            <mrow>
               <mi>t</mi>
            </mrow>
         </msub>
      </mrow>
      <mrow>
         <msub>
            <mrow>
               <mi>A</mi>
            </mrow>
            <mrow>
               <mi>i</mi>
            </mrow>
         </msub>
      </mrow>
   </mfrac>
</math>
the reflection and transmission coefficients for pressure (notice the sign
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi>–</mi>
</math>
on the front of
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi>x</mi>
</math>
for the reflected wave which is the consequence of the definition of
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>r</mi>
      </mrow>
   </msub>
</math>). At the interface (<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi>x</mi>
   <mo class=MathClass-rel>=</mo>
   <mn>0</mn>
</math>) there is continuity of pressure, then
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>p</mi>
      </mrow>
      <mrow>
         <mi>i</mi>
      </mrow>
   </msub>
   <mo class=MathClass-open>(</mo>
   <mi>x</mi>
   <mo class=MathClass-rel>=</mo>
   <msup>
      <mrow>
         <mn>0</mn>
      </mrow>
      <mrow>
         <mo class=MathClass-bin>−</mo>
      </mrow>
   </msup>
   <mo class=MathClass-close>)</mo>
   <mo class=MathClass-bin>+</mo>
   <msub>
      <mrow>
         <mi>p</mi>
      </mrow>
      <mrow>
         <mi>r</mi>
      </mrow>
   </msub>
   <mo class=MathClass-open>(</mo>
   <mi>x</mi>
   <mo class=MathClass-rel>=</mo>
   <msup>
      <mrow>
         <mn>0</mn>
      </mrow>
      <mrow>
         <mo class=MathClass-bin>−</mo>
      </mrow>
   </msup>
   <mo class=MathClass-close>)</mo>
   <mo class=MathClass-rel>=</mo>
   <msub>
      <mrow>
         <mi>p</mi>
      </mrow>
      <mrow>
         <mi>t</mi>
      </mrow>
   </msub>
   <mo class=MathClass-open>(</mo>
   <mi>x</mi>
   <mo class=MathClass-rel>=</mo>
   <msup>
      <mrow>
         <mn>0</mn>
      </mrow>
      <mrow>
         <mo class=MathClass-bin>+</mo>
      </mrow>
   </msup>
   <mo class=MathClass-close>)</mo>
</math>. So, for any
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi>y</mi>
</math>,
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msup>
      <mrow>
         <mi>e</mi>
      </mrow>
      <mrow>
         <mo class=MathClass-bin>−</mo>
         <mi>j</mi>
         <msub>
            <mrow>
               <mi>k</mi>
            </mrow>
            <mrow>
               <mn>1</mn>
            </mrow>
         </msub>
         <mi>y</mi>
         <mi class=qopname>sin</mi>
         <mo>⁡</mo>
         <msub>
            <mrow>
               <mi>𝜃</mi>
            </mrow>
            <mrow>
               <mi>i</mi>
            </mrow>
         </msub>
      </mrow>
   </msup>
   <mo class=MathClass-bin>+</mo>
   <msub>
      <mrow>
         <mi>R</mi>
      </mrow>
      <mrow>
         <mi>p</mi>
      </mrow>
   </msub>
   <msup>
      <mrow>
         <mi>e</mi>
      </mrow>
      <mrow>
         <mo class=MathClass-bin>−</mo>
         <mi>j</mi>
         <msub>
            <mrow>
               <mi>k</mi>
            </mrow>
            <mrow>
               <mn>1</mn>
            </mrow>
         </msub>
         <mi>y</mi>
         <mi class=qopname>sin</mi>
         <mo>⁡</mo>
         <msub>
            <mrow>
               <mi>𝜃</mi>
            </mrow>
            <mrow>
               <mi>r</mi>
            </mrow>
         </msub>
      </mrow>
   </msup>
   <mo class=MathClass-rel>=</mo>
   <msub>
      <mrow>
         <mi>T</mi>
      </mrow>
      <mrow>
         <mi>p</mi>
      </mrow>
   </msub>
   <msup>
      <mrow>
         <mi>e</mi>
      </mrow>
      <mrow>
         <mo class=MathClass-bin>−</mo>
         <mi>j</mi>
         <msub>
            <mrow>
               <mi>k</mi>
            </mrow>
            <mrow>
               <mn>2</mn>
            </mrow>
         </msub>
         <mi>y</mi>
         <mi class=qopname>sin</mi>
         <mo>⁡</mo>
         <msub>
            <mrow>
               <mi>𝜃</mi>
            </mrow>
            <mrow>
               <mi>t</mi>
            </mrow>
         </msub>
      </mrow>
   </msup>
</math>. This equality is valid for any
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi>y</mi>
</math>
only if the exponential arguments are identical, that is to say if:
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>k</mi>
      </mrow>
      <mrow>
         <mn>1</mn>
      </mrow>
   </msub>
   <mi>y</mi>
   <mi class=qopname>sin</mi>
   <mo>⁡</mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>i</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <msub>
      <mrow>
         <mi>k</mi>
      </mrow>
      <mrow>
         <mn>1</mn>
      </mrow>
   </msub>
   <mi>y</mi>
   <mi class=qopname>sin</mi>
   <mo>⁡</mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>r</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <msub>
      <mrow>
         <mi>k</mi>
      </mrow>
      <mrow>
         <mn>2</mn>
      </mrow>
   </msub>
   <mi>y</mi>
   <mi class=qopname>sin</mi>
   <mo>⁡</mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>t</mi>
      </mrow>
   </msub>
</math>.
<p>
Then, on the one hand
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>i</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>r</mi>
      </mrow>
   </msub>
</math>
and on the other hand
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mfrac>
      <mrow>
         <mi class=qopname>sin</mi>
         <mo>⁡</mo>
         <msub>
            <mrow>
               <mi>𝜃</mi>
            </mrow>
            <mrow>
               <mi>i</mi>
            </mrow>
         </msub>
      </mrow>
      <mrow>
         <msub>
            <mrow>
               <mi>c</mi>
            </mrow>
            <mrow>
               <mn>1</mn>
            </mrow>
         </msub>
      </mrow>
   </mfrac>
   <mo class=MathClass-rel>=</mo>
   <mfrac>
      <mrow>
         <mi class=qopname>sin</mi>
         <mo>⁡</mo>
         <msub>
            <mrow>
               <mi>𝜃</mi>
            </mrow>
            <mrow>
               <mi>t</mi>
            </mrow>
         </msub>
      </mrow>
      <mrow>
         <msub>
            <mrow>
               <mi>c</mi>
            </mrow>
            <mrow>
               <mn>2</mn>
            </mrow>
         </msub>
      </mrow>
   </mfrac>
</math>. These are the Snell-Descartes’s laws, well known in optics for the reflection and refraction of light. The Snell-Descartes’s law being satisfied, the continuity of the pressure leads to
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mn>1</mn>
   <mo class=MathClass-bin>+</mo>
   <msub>
      <mrow>
         <mi>R</mi>
      </mrow>
      <mrow>
         <mi>p</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <msub>
      <mrow>
         <mi>T</mi>
      </mrow>
      <mrow>
         <mi>p</mi>
      </mrow>
   </msub>
</math>, as was found for normal incidence (see <a href="${linkLesson0106}" target="_blank">Lesson 1.6</a>).
<h3 class=sectionHead>Critical angle and evanescent wave concept</h3>
<p>
Note that second Snell-Descartes’s law is problematic when
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>c</mi>
      </mrow>
      <mrow>
         <mn>2</mn>
      </mrow>
   </msub>
   <mo class=MathClass-rel>></mo>
   <msub>
      <mrow>
         <mi>c</mi>
      </mrow>
      <mrow>
         <mn>1</mn>
      </mrow>
   </msub>
</math>. Indeed, in this case, there is an angle of incidence
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>i</mi>
      </mrow>
   </msub>
</math>, called the critical angle
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>c</mi>
      </mrow>
   </msub>
</math>, above which
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi class=qopname>sin</mi>
   <mo>⁡</mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>t</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>></mo>
   <mn>1</mn>
</math>, which is a priori not possible. The critical angle is obtained for
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi class=qopname>sin</mi>
   <mo>⁡</mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>t</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <mn>1</mn>
</math>
and is given by
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi class=qopname>sin</mi>
   <mo>⁡</mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>c</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <mfrac>
      <mrow>
         <msub>
            <mrow>
               <mi>c</mi>
            </mrow>
            <mrow>
               <mn>1</mn>
            </mrow>
         </msub>
      </mrow>
      <mrow>
         <msub>
            <mrow>
               <mi>c</mi>
            </mrow>
            <mrow>
               <mn>2</mn>
            </mrow>
         </msub>
      </mrow>
   </mfrac>
</math>. The practical consequence is that for an angle larger than the critical angle, there is no wave propagating in the second medium. In fact, we can override the fact that the angle does not exist if
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi class=qopname>sin</mi>
   <mo>⁡</mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>t</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>></mo>
   <mn>1</mn>
</math>
writing:
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi class=qopname>cos</mi>
   <mo>⁡</mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>t</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <msqrt>
      <mrow>
         <mn>1</mn>
         <mo class=MathClass-bin>−</mo>
         <msup>
            <mrow>
               <mi class=qopname>sin</mi>
               <mo>⁡</mo>
            </mrow>
            <mrow>
               <mn>2</mn>
            </mrow>
         </msup>
         <msub>
            <mrow>
               <mi>𝜃</mi>
            </mrow>
            <mrow>
               <mi>t</mi>
            </mrow>
         </msub>
      </mrow>
   </msqrt>
   <mo class=MathClass-rel>=</mo>
   <msqrt>
      <mrow>
         <mn>1</mn>
         <mo class=MathClass-bin>−</mo>
         <msup>
            <mrow>
               <mo class=MathClass-open>(</mo>
               <mfrac>
                  <mrow>
                     <msub>
                        <mrow>
                           <mi>c</mi>
                        </mrow>
                        <mrow>
                           <mn>2</mn>
                        </mrow>
                     </msub>
                  </mrow>
                  <mrow>
                     <msub>
                        <mrow>
                           <mi>c</mi>
                        </mrow>
                        <mrow>
                           <mn>1</mn>
                        </mrow>
                     </msub>
                  </mrow>
               </mfrac>
               <mi class=qopname>sin</mi>
               <mo>⁡</mo>
               <msub>
                  <mrow>
                     <mi>𝜃</mi>
                  </mrow>
                  <mrow>
                     <mi>i</mi>
                  </mrow>
               </msub>
               <mo class=MathClass-close>)</mo>
            </mrow>
            <mrow>
               <mn>2</mn>
            </mrow>
         </msup>
      </mrow>
   </msqrt>
</math>. If
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi class=qopname>sin</mi>
   <mo>⁡</mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>t</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>></mo>
   <mn>1</mn>
</math>
the cosine is purely imaginary:
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi class=qopname>cos</mi>
   <mo>⁡</mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>t</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <mo class=MathClass-bin>±</mo>
   <mi>j</mi>
   <msqrt>
      <mrow>
         <msup>
            <mrow>
               <mo class=MathClass-open>(</mo>
               <mfrac>
                  <mrow>
                     <msub>
                        <mrow>
                           <mi>c</mi>
                        </mrow>
                        <mrow>
                           <mn>2</mn>
                        </mrow>
                     </msub>
                  </mrow>
                  <mrow>
                     <msub>
                        <mrow>
                           <mi>c</mi>
                        </mrow>
                        <mrow>
                           <mn>1</mn>
                        </mrow>
                     </msub>
                  </mrow>
               </mfrac>
               <mi class=qopname>sin</mi>
               <mo>⁡</mo>
               <msub>
                  <mrow>
                     <mi>𝜃</mi>
                  </mrow>
                  <mrow>
                     <mi>i</mi>
                  </mrow>
               </msub>
               <mo class=MathClass-close>)</mo>
            </mrow>
            <mrow>
               <mn>2</mn>
            </mrow>
         </msup>
         <mo class=MathClass-bin>−</mo>
         <mn>1</mn>
      </mrow>
   </msqrt>
</math>. The pressure of the transmitted wave thus writes
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>p</mi>
      </mrow>
      <mrow>
         <mi>t</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <msub>
      <mrow>
         <mi>T</mi>
      </mrow>
      <mrow>
         <mi>p</mi>
      </mrow>
   </msub>
   <msup>
      <mrow>
         <mi>e</mi>
      </mrow>
      <mrow>
         <mo class=MathClass-bin>−</mo>
         <mi>j</mi>
         <msub>
            <mrow>
               <mi>k</mi>
            </mrow>
            <mrow>
               <mn>2</mn>
            </mrow>
         </msub>
         <mo class=MathClass-open>(</mo>
         <mo class=MathClass-bin>−</mo>
         <mi mathvariant=italic>jx</mi>
         <msqrt>
            <mrow>
               <msup>
                  <mrow>
                     <mi class=qopname>sin</mi>
                     <mo>⁡</mo>
                  </mrow>
                  <mrow>
                     <mn>2</mn>
                  </mrow>
               </msup>
               <msub>
                  <mrow>
                     <mi>𝜃</mi>
                  </mrow>
                  <mrow>
                     <mi>t</mi>
                  </mrow>
               </msub>
               <mo class=MathClass-bin>−</mo>
               <mn>1</mn>
            </mrow>
         </msqrt>
         <mo class=MathClass-bin>+</mo>
         <mi>y</mi>
         <mi class=qopname>sin</mi>
         <mo>⁡</mo>
         <msub>
            <mrow>
               <mi>𝜃</mi>
            </mrow>
            <mrow>
               <mi>t</mi>
            </mrow>
         </msub>
         <mo class=MathClass-close>)</mo>
      </mrow>
   </msup>
   <mo class=MathClass-rel>=</mo>
   </math>
   <math display=inline xmlns=http://www.w3.org/1998/Math/MathML>

   <msub>
      <mrow>
         <mi>T</mi>
      </mrow>
      <mrow>
         <mi>p</mi>
      </mrow>
   </msub>
   <msup>
      <mrow>
         <mi>e</mi>
      </mrow>
      <mrow>
         <mo class=MathClass-bin>−</mo>
         <msub>
            <mrow>
               <mi>k</mi>
            </mrow>
            <mrow>
               <mn>2</mn>
            </mrow>
         </msub>
         <mi>x</mi>
         <msqrt>
            <mrow>
               <msup>
                  <mrow>
                     <mi class=qopname>sin</mi>
                     <mo>⁡</mo>
                  </mrow>
                  <mrow>
                     <mn>2</mn>
                  </mrow>
               </msup>
               <msub>
                  <mrow>
                     <mi>𝜃</mi>
                  </mrow>
                  <mrow>
                     <mi>t</mi>
                  </mrow>
               </msub>
               <mo class=MathClass-bin>−</mo>
               <mn>1</mn>
            </mrow>
         </msqrt>
      </mrow>
   </msup>
   <msup>
      <mrow>
         <mi>e</mi>
      </mrow>
      <mrow>
         <mo class=MathClass-bin>−</mo>
         <mi>j</mi>
         <msub>
            <mrow>
               <mi>k</mi>
            </mrow>
            <mrow>
               <mn>1</mn>
            </mrow>
         </msub>
         <mi>y</mi>
         <mi class=qopname>sin</mi>
         <mo>⁡</mo>
         <msub>
            <mrow>
               <mi>𝜃</mi>
            </mrow>
            <mrow>
               <mi>i</mi>
            </mrow>
         </msub>
      </mrow>
   </msup>
</math>. It is then noted that there is no propagation in the
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi>x</mi>
</math>
direction as the pressure amplitude decreases exponentially with
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi>x</mi>
</math>. In this case it can be said that we have an evanescent wave (an evanescent wave is a wave that does not propagate and whose amplitude decays exponentially). Note that the wave propagates along
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi>y</mi>
</math>, so this is what can be called a surface wave that propagates along
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi>y</mi>
</math>
at the same speed as the incident wave.
<h3 class=sectionHead>Reflection and transmission coefficients</h3>
<p>
There is continuity of normal velocity at the interface (note that there is not continuity of the tangent velocity at the interface). We can write:
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>v</mi>
      </mrow>
      <mrow>
         <mi mathvariant=italic>xi</mi>
      </mrow>
   </msub>
   <mo class=MathClass-open>(</mo>
   <mi>x</mi>
   <mo class=MathClass-rel>=</mo>
   <msup>
      <mrow>
         <mn>0</mn>
      </mrow>
      <mrow>
         <mo class=MathClass-bin>−</mo>
      </mrow>
   </msup>
   <mo class=MathClass-close>)</mo>
   <mo class=MathClass-bin>+</mo>
   <msub>
      <mrow>
         <mi>v</mi>
      </mrow>
      <mrow>
         <mi mathvariant=italic>xr</mi>
      </mrow>
   </msub>
   <mo class=MathClass-open>(</mo>
   <mi>x</mi>
   <mo class=MathClass-rel>=</mo>
   <msup>
      <mrow>
         <mn>0</mn>
      </mrow>
      <mrow>
         <mo class=MathClass-bin>−</mo>
      </mrow>
   </msup>
   <mo class=MathClass-close>)</mo>
   <mo class=MathClass-rel>=</mo>
   <msub>
      <mrow>
         <mi>v</mi>
      </mrow>
      <mrow>
         <mi mathvariant=italic>xt</mi>
      </mrow>
   </msub>
   <mo class=MathClass-open>(</mo>
   <mi>x</mi>
   <mo class=MathClass-rel>=</mo>
   <msup>
      <mrow>
         <mn>0</mn>
      </mrow>
      <mrow>
         <mo class=MathClass-bin>+</mo>
      </mrow>
   </msup>
   <mo class=MathClass-close>)</mo>
</math>. As for a plane wave,
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>

      <mi mathvariant="bold">v</mi>
<mo class=MathClass-rel>=</mo>
<mfrac>
   <mrow>
      <mi>p</mi>
   </mrow>
   <mrow>
      <msub>
         <mrow>
            <mi>ρ</mi>
         </mrow>
         <mrow>
            <mn>0</mn>
         </mrow>
      </msub>
      <mi>c</mi>
   </mrow>
</mfrac>
      <mi mathvariant="bold">n</mi>
</math>. So
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>v</mi>
      </mrow>
      <mrow>
         <mi mathvariant=italic>xi</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <mfrac>
      <mrow>
         <msub>
            <mrow>
               <mi>p</mi>
            </mrow>
            <mrow>
               <mi>i</mi>
            </mrow>
         </msub>
      </mrow>
      <mrow>
         <msub>
            <mrow>
               <mi>ρ</mi>
            </mrow>
            <mrow>
               <mn>1</mn>
            </mrow>
         </msub>
         <msub>
            <mrow>
               <mi>c</mi>
            </mrow>
            <mrow>
               <mn>1</mn>
            </mrow>
         </msub>
      </mrow>
   </mfrac>
   <mi class=qopname>cos</mi>
   <mo>⁡</mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>i</mi>
      </mrow>
   </msub>
</math>,
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>v</mi>
      </mrow>
      <mrow>
         <mi mathvariant=italic>xt</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <mo class=MathClass-bin>−</mo>
   <mfrac>
      <mrow>
         <msub>
            <mrow>
               <mi>p</mi>
            </mrow>
            <mrow>
               <mi>t</mi>
            </mrow>
         </msub>
      </mrow>
      <mrow>
         <msub>
            <mrow>
               <mi>ρ</mi>
            </mrow>
            <mrow>
               <mn>1</mn>
            </mrow>
         </msub>
         <msub>
            <mrow>
               <mi>c</mi>
            </mrow>
            <mrow>
               <mn>1</mn>
            </mrow>
         </msub>
      </mrow>
   </mfrac>
   <mi class=qopname>cos</mi>
   <mo>⁡</mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>i</mi>
      </mrow>
   </msub>
</math>
and
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi mathvariant=italic>vxi</mi>
   <mo class=MathClass-rel>=</mo>
   <mfrac>
      <mrow>
         <msub>
            <mrow>
               <mi>p</mi>
            </mrow>
            <mrow>
               <mi>t</mi>
            </mrow>
         </msub>
      </mrow>
      <mrow>
         <msub>
            <mrow>
               <mi>ρ</mi>
            </mrow>
            <mrow>
               <mn>2</mn>
            </mrow>
         </msub>
         <msub>
            <mrow>
               <mi>c</mi>
            </mrow>
            <mrow>
               <mn>2</mn>
            </mrow>
         </msub>
      </mrow>
   </mfrac>
   <mi class=qopname>cos</mi>
   <mo>⁡</mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>t</mi>
      </mrow>
   </msub>
</math>. At
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi>x</mi>
   <mo class=MathClass-rel>=</mo>
   <mn>0</mn>
</math>
one has
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mfrac>
      <mrow>
         <mi class=qopname>cos</mi>
         <mo>⁡</mo>
         <msub>
            <mrow>
               <mi>𝜃</mi>
            </mrow>
            <mrow>
               <mi>i</mi>
            </mrow>
         </msub>
      </mrow>
      <mrow>
         <msub>
            <mrow>
               <mi>ρ</mi>
            </mrow>
            <mrow>
               <mn>1</mn>
            </mrow>
         </msub>
         <msub>
            <mrow>
               <mi>c</mi>
            </mrow>
            <mrow>
               <mn>1</mn>
            </mrow>
         </msub>
      </mrow>
   </mfrac>
   <mo class=MathClass-bin>−</mo>
   <msub>
      <mrow>
         <mi>R</mi>
      </mrow>
      <mrow>
         <mi>p</mi>
      </mrow>
   </msub>
   <mfrac>
      <mrow>
         <mi class=qopname>cos</mi>
         <mo>⁡</mo>
         <msub>
            <mrow>
               <mi>𝜃</mi>
            </mrow>
            <mrow>
               <mi>i</mi>
            </mrow>
         </msub>
      </mrow>
      <mrow>
         <msub>
            <mrow>
               <mi>ρ</mi>
            </mrow>
            <mrow>
               <mn>1</mn>
            </mrow>
         </msub>
         <msub>
            <mrow>
               <mi>c</mi>
            </mrow>
            <mrow>
               <mn>1</mn>
            </mrow>
         </msub>
      </mrow>
   </mfrac>
   <mo class=MathClass-rel>=</mo>
   <msub>
      <mrow>
         <mi>T</mi>
      </mrow>
      <mrow>
         <mi>p</mi>
      </mrow>
   </msub>
   <mfrac>
      <mrow>
         <mi class=qopname>cos</mi>
         <mo>⁡</mo>
         <msub>
            <mrow>
               <mi>𝜃</mi>
            </mrow>
            <mrow>
               <mi>t</mi>
            </mrow>
         </msub>
      </mrow>
      <mrow>
         <msub>
            <mrow>
               <mi>ρ</mi>
            </mrow>
            <mrow>
               <mn>2</mn>
            </mrow>
         </msub>
         <msub>
            <mrow>
               <mi>c</mi>
            </mrow>
            <mrow>
               <mn>2</mn>
            </mrow>
         </msub>
      </mrow>
   </mfrac>
</math>. This equation combined with that obtained by writing pressure continuity leads to the following system
<table class=equation>
<tr>
   <td>
      <math xmlns=http://www.w3.org/1998/Math/MathML class=equation display=block>
         <mrow>
            <mo form=prefix fence=true>{</mo>
            <mrow>
              <mfrac linethickness=0 numalign="right">
              <mrow>
               <mn>1</mn>
               <mo class=MathClass-bin>+</mo>
               <msub>
                  <mrow>
                     <mi>R</mi>
                  </mrow>
                  <mrow>
                     <mi>p</mi>
                  </mrow>
               </msub>
               <mo class=MathClass-rel>=</mo>
               <msub>
                  <mrow>
                     <mi>T</mi>
                  </mrow>
                  <mrow>
                     <mi>p</mi>
                  </mrow>
               </msub>
               </mrow>
               <mrow>
               <mn>1</mn>
               <mo class=MathClass-bin>−</mo>
               <msub>
                  <mrow>
                     <mi>R</mi>
                  </mrow>
                  <mrow>
                     <mi>p</mi>
                  </mrow>
               </msub>
               <mo class=MathClass-rel>=</mo>
               <mfrac>
                  <mrow>
                     <msub>
                        <mrow>
                           <mi>ρ</mi>
                        </mrow>
                        <mrow>
                           <mn>1</mn>
                        </mrow>
                     </msub>
                     <msub>
                        <mrow>
                           <mi>c</mi>
                        </mrow>
                        <mrow>
                           <mn>1</mn>
                        </mrow>
                     </msub>
                     <mi class=qopname>cos</mi>
                     <mo>⁡</mo>
                     <msub>
                        <mrow>
                           <mi>𝜃</mi>
                        </mrow>
                        <mrow>
                           <mi>t</mi>
                        </mrow>
                     </msub>
                  </mrow>
                  <mrow>
                     <msub>
                        <mrow>
                           <mi>ρ</mi>
                        </mrow>
                        <mrow>
                           <mn>2</mn>
                        </mrow>
                     </msub>
                     <msub>
                        <mrow>
                           <mi>c</mi>
                        </mrow>
                        <mrow>
                           <mn>2</mn>
                        </mrow>
                     </msub>
                     <mi class=qopname>cos</mi>
                     <mo>⁡</mo>
                     <msub>
                        <mrow>
                           <mi>𝜃</mi>
                        </mrow>
                        <mrow>
                           <mi>i</mi>
                        </mrow>
                     </msub>
                  </mrow>
               </mfrac>
               </mrow>
               </mfrac>
         </mrow>
      </math>
   <td class=eq-no>(1)
</table>
<p>which leads to
<table class=equation>
<tr>
   <td>
      <math xmlns=http://www.w3.org/1998/Math/MathML class=equation display=block>
         <mrow>
            <mo form=prefix fence=true>{</mo>
            <mfrac linethickness=0 numalign="left">
            <mrow>

               <msub>
                  <mrow>
                     <mi>R</mi>
                  </mrow>
                  <mrow>
                     <mi>p</mi>
                  </mrow>
               </msub>
               <mo class=MathClass-rel>=</mo>
               <mfrac>
                  <mrow>
                     <mfrac>
                        <mrow>
                           <msub>
                              <mrow>
                                 <mi>ρ</mi>
                              </mrow>
                              <mrow>
                                 <mn>2</mn>
                              </mrow>
                           </msub>
                           <msub>
                              <mrow>
                                 <mi>c</mi>
                              </mrow>
                              <mrow>
                                 <mn>2</mn>
                              </mrow>
                           </msub>
                        </mrow>
                        <mrow>
                           <mi class=qopname>cos</mi>
                           <mo>⁡</mo>
                           <msub>
                              <mrow>
                                 <mi>𝜃</mi>
                              </mrow>
                              <mrow>
                                 <mi>t</mi>
                              </mrow>
                           </msub>
                        </mrow>
                     </mfrac>
                     <mo class=MathClass-bin>−</mo>
                     <mfrac>
                        <mrow>
                           <msub>
                              <mrow>
                                 <mi>ρ</mi>
                              </mrow>
                              <mrow>
                                 <mn>1</mn>
                              </mrow>
                           </msub>
                           <msub>
                              <mrow>
                                 <mi>c</mi>
                              </mrow>
                              <mrow>
                                 <mn>1</mn>
                              </mrow>
                           </msub>
                        </mrow>
                        <mrow>
                           <mi class=qopname>cos</mi>
                           <mo>⁡</mo>
                           <msub>
                              <mrow>
                                 <mi>𝜃</mi>
                              </mrow>
                              <mrow>
                                 <mi>i</mi>
                              </mrow>
                           </msub>
                        </mrow>
                     </mfrac>
                  </mrow>
                  <mrow>
                     <mfrac>
                        <mrow>
                           <msub>
                              <mrow>
                                 <mi>ρ</mi>
                              </mrow>
                              <mrow>
                                 <mn>2</mn>
                              </mrow>
                           </msub>
                           <msub>
                              <mrow>
                                 <mi>c</mi>
                              </mrow>
                              <mrow>
                                 <mn>2</mn>
                              </mrow>
                           </msub>
                        </mrow>
                        <mrow>
                           <mi class=qopname>cos</mi>
                           <mo>⁡</mo>
                           <msub>
                              <mrow>
                                 <mi>𝜃</mi>
                              </mrow>
                              <mrow>
                                 <mi>t</mi>
                              </mrow>
                           </msub>
                        </mrow>
                     </mfrac>
                     <mo class=MathClass-bin>+</mo>
                     <mfrac>
                        <mrow>
                           <msub>
                              <mrow>
                                 <mi>ρ</mi>
                              </mrow>
                              <mrow>
                                 <mn>1</mn>
                              </mrow>
                           </msub>
                           <msub>
                              <mrow>
                                 <mi>c</mi>
                              </mrow>
                              <mrow>
                                 <mn>1</mn>
                              </mrow>
                           </msub>
                        </mrow>
                        <mrow>
                           <mi class=qopname>cos</mi>
                           <mo>⁡</mo>
                           <msub>
                              <mrow>
                                 <mi>𝜃</mi>
                              </mrow>
                              <mrow>
                                 <mi>i</mi>
                              </mrow>
                           </msub>
                        </mrow>
                     </mfrac>
                  </mrow>
               </mfrac>
               </mrow>
               <mrow>
               <msub>
                  <mrow>
                     <mi>T</mi>
                  </mrow>
                  <mrow>
                     <mi>p</mi>
                  </mrow>
               </msub>
               <mo class=MathClass-rel>=</mo>
               <mfrac>
                  <mrow>
                     <mn>2</mn>
                     <mfrac>
                        <mrow>
                           <msub>
                              <mrow>
                                 <mi>ρ</mi>
                              </mrow>
                              <mrow>
                                 <mn>2</mn>
                              </mrow>
                           </msub>
                           <msub>
                              <mrow>
                                 <mi>c</mi>
                              </mrow>
                              <mrow>
                                 <mn>2</mn>
                              </mrow>
                           </msub>
                        </mrow>
                        <mrow>
                           <mi class=qopname>cos</mi>
                           <mo>⁡</mo>
                           <msub>
                              <mrow>
                                 <mi>𝜃</mi>
                              </mrow>
                              <mrow>
                                 <mi>t</mi>
                              </mrow>
                           </msub>
                        </mrow>
                     </mfrac>
                  </mrow>
                  <mrow>
                     <mfrac>
                        <mrow>
                           <msub>
                              <mrow>
                                 <mi>ρ</mi>
                              </mrow>
                              <mrow>
                                 <mn>2</mn>
                              </mrow>
                           </msub>
                           <msub>
                              <mrow>
                                 <mi>c</mi>
                              </mrow>
                              <mrow>
                                 <mn>2</mn>
                              </mrow>
                           </msub>
                        </mrow>
                        <mrow>
                           <mi class=qopname>cos</mi>
                           <mo>⁡</mo>
                           <msub>
                              <mrow>
                                 <mi>𝜃</mi>
                              </mrow>
                              <mrow>
                                 <mi>t</mi>
                              </mrow>
                           </msub>
                        </mrow>
                     </mfrac>
                     <mo class=MathClass-bin>+</mo>
                     <mfrac>
                        <mrow>
                           <msub>
                              <mrow>
                                 <mi>ρ</mi>
                              </mrow>
                              <mrow>
                                 <mn>1</mn>
                              </mrow>
                           </msub>
                           <msub>
                              <mrow>
                                 <mi>c</mi>
                              </mrow>
                              <mrow>
                                 <mn>1</mn>
                              </mrow>
                           </msub>
                        </mrow>
                        <mrow>
                           <mi class=qopname>cos</mi>
                           <mo>⁡</mo>
                           <msub>
                              <mrow>
                                 <mi>𝜃</mi>
                              </mrow>
                              <mrow>
                                 <mi>i</mi>
                              </mrow>
                           </msub>
                        </mrow>
                     </mfrac>
                  </mrow>
               </mfrac>
         </mrow>
      </math>
   <td class=eq-no>(2)
</table>
<p>
Note that if
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>i</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>t</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>=</mo>
   <mn>0</mn>
</math>, we retrieve the expressions found in normal incidence (see <a href="${linkLesson0106}" target="_blank">Lesson 1.6</a>).
<p>
In the case where
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>i</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>></mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>c</mi>
      </mrow>
   </msub>
</math>,
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi class=qopname>cos</mi>
   <mo>⁡</mo>
   <msub>
      <mrow>
         <mi>𝜃</mi>
      </mrow>
      <mrow>
         <mi>t</mi>
      </mrow>
   </msub>
</math>
is purely imaginary and consequently
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mo class=MathClass-rel>|</mo>
   <msub>
      <mrow>
         <mi>R</mi>
      </mrow>
      <mrow>
         <mi>p</mi>
      </mrow>
   </msub>
   <mo class=MathClass-rel>|</mo>
   <mo class=MathClass-rel>=</mo>
   <mn>1</mn>
</math>
and
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>T</mi>
      </mrow>
      <mrow>
         <mi>p</mi>
      </mrow>
   </msub>
</math>
is in quadrature with
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <msub>
      <mrow>
         <mi>T</mi>
      </mrow>
      <mrow>
         <mi>v</mi>
      </mrow>
   </msub>
</math>
which imply that transmitted pressure and velocity are also in quadrature and do not carry energy. This comforts the analysis that transmitted waves is a surface wave. In other words, the incident wave is totally reflected with some delay
<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
   <mi>τ</mi>
   <mo class=MathClass-rel>=</mo>
   <mfrac>
      <mrow>
         <mi mathvariant=italic>Arg</mi>
         <mo class=MathClass-open>(</mo>
         <msub>
            <mrow>
               <mi>R</mi>
            </mrow>
            <mrow>
               <mi>p</mi>
            </mrow>
         </msub>
         <mo class=MathClass-close>)</mo>
      </mrow>
      <mrow>
         <mi>ω</mi>
      </mrow>
   </mfrac>
</math>.
<h3 class=sectionHead>References</h3>
<dl class=thebibliography>
   <dt>[1]
   <dd>L.J. Beranek. Acoustics. The American Institute of Physics, New York, 1986.
   <dt>[2]
   <dd>M. Bruneau. Manuel d’Acoustique Fondamentale. Hermes, Paris, 1998.
   <dt>[3]
   <dd>A. Chaigne and J. Kergomard. Acoustics of Musical Instruments. Springer, New York, 2016.
   <dt>[4]
   <dd>A.D. Pierce. Acoustics: an Introduction to its Physical Principles and Applications. MCGraw-Hill Book Company, Inc., New York, 1981.
   <dt>[5]
   <dd>E. Skudrzyk. The Foundations of Acoustics—Basic Mathematics and Basic Acoustics. Springer–Verlag, 1971.
   <dt>[6]
   <dd>S. Temkin. Elements of Acoustics. Wiley, New York, 1981.
   </dl>`;

export default theory;
